import Fetch from '../../../mixins/Fetch'

const loadUnidades = async ({ commit }, params) => {
  const request = Fetch.get('unit/get', params)

  if (request.status === 'error') throw new Error(request.message)

  const result = request
  const units = []

  result.then((r) =>
    r.map((data) => units.push({ value: data.id, text: data.nome }))
  )

  commit('SETUNITS', units)
}

const loadProfiles = async ({ commit }) => {
  const request = Fetch.get('profile/get')

  if (request.status === 'error') throw new Error(request.message)

  const result = request
  const profiles = []

  result.then((r) =>
    r.map((data) => profiles.push({ value: data.id, text: data.descricao }))
  )

  commit('SETPROFILES', profiles)
}

const loadUsers = async ({ commit }) => {
  const request = Fetch.get('user/get')

  if (request.status === 'error') throw new Error(request.message)

  const result = request
  const users = []

  result.then((r) =>
    r.map((data) =>
      users.push({
        id: data.id,
        nome: data.nome,
        email: data.email,
        perfil: data.descricao,
        editar: null,
        LGPD: data.dataAceiteLGPD === null ? 'Pendente' : 'De acordo'
      })
    )
  )

  commit('SETUSERS', users)
}

const loadPermissionUnit = async ({ commit }, params) => {
  const request = Fetch.get('user/getpermissunit', params)

  if (request.status === 'error') throw new Error(request.message)

  const result = request
  const permissions = []

  result.then((data) =>
    data.map((a) => permissions.push({ value: a.id, text: a.nome }))
  )

  commit('SETPERMISSAOUNI', permissions)
}

const loadUserById = async ({ commit }, params) => {
  const request = Fetch.get('user/getById', params)

  if (request.status === 'error') throw new Error(request.message)

  const result = request

  return result
}

const postEditUser = async ({ commit }, params) => {
  const request = Fetch.post('user/up', params)

  if (request.status === 'error') throw new Error(request.message)

  return request
}

const lgpdAccept = async ({ commit }, params) => {
  const formData = new FormData()
  formData.append('userId', params)
  const request = Fetch.post('user/lgpdAccept', formData)

  if (request.status === 'error') throw new Error(request.message)

  localStorage.setItem('lgpdAccept', true)

  return request
}

const postRegisterUser = async ({ commit }, params) => {
  const request = Fetch.post('user/add', params)

  if (request.status === 'error') throw new Error(request.message)

  return request
}

const loadPermissaoServ = async ({ commit }, params) => {
  const request = Fetch.get('service/getPermissionService', params)

  if (request.status === 'error') throw new Error(request.message)

  const response = []
  request.then(res => res.map(x => response.push({ text: x.nome, value: x.idTipoServico })))

  commit('SETPERMISSAOSERV', response)
}

const exportListToXlsx = async ({ commit }) => {
  const request = await Fetch.get('user/exportToXlsx')

  if (request.status === 'error') throw new Error(request.message)

  const bytes = request.fileContents
  const mediaType =
    'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'
  const url = mediaType + bytes
  const a = document.createElement('a')
  a.href = url
  a.download = request.fileDownloadName
  a.click()
  window.URL.revokeObjectURL(url)
  a.remove()

  commit('SETUSERLISTDOWNLOAD')
}

export default {
  loadUnidades,
  loadProfiles,
  loadUsers,
  loadPermissionUnit,
  loadUserById,
  postEditUser,
  postRegisterUser,
  lgpdAccept,
  loadPermissaoServ,
  exportListToXlsx
}
